import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import View from "./View";

const NotEligible = ({ project, onNext, onBack, currentStatus, tracer }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("NOT_ELIGIBLE", { returnObjects: true });
  return <View onBack={onBack} project={project} translate={TRANSLATION} />;
};

export default NotEligible;
